import { showErrorAPI, showSuccessToast } from "@/services/apiRoutes";
import { Invite, UserRoute } from "@/services/apiRoutes/routes";
import {
  convertNotificationResponse,
  getNotificationList,
  markAllAsReadNotification,
} from "@/services/common/notificationServices";
import {
  deleteAllNotification,
  deleteNotification,
  makeAsUnread,
} from "@/services/org";
import store from "..";
import { getComponentUiText } from "@/utils/utilities";
import { successStatusCodes } from "@/utils/constants";

export default {
  namespaced: true,

  state() {
    return {
      isLoadAfterLogin: false,
      notification: [],
      systemActions: 0,
    };
  },

  getters: {},

  mutations: {
    SET_NOTIFICATION: (state: any, data: any) => {
      state.notification = data;
    },

    SET_SYSTEM_ACTIONS: (state: any, data: any) => {
      state.systemActions = data;
    },

    SET_LOAD_AFTER_LOGIN: (state: any, data: any) => {
      state.isLoadAfterLogin = data;
    },
  },

  actions: {
    getNotification: async ({ commit }: any, params: any) => {
      try {
        const response = await getNotificationList(params);

        const { totalNew, action } = convertNotificationResponse(response);
        commit("SET_SYSTEM_ACTIONS", totalNew);
        commit("SET_NOTIFICATION", action);
      } catch (error) {
        showErrorAPI(error, Invite.getSystemActions);
      }
    },

    setSystemActions: async ({ commit }: any, params: any) => {
      commit("SET_SYSTEM_ACTIONS", params);
    },

    setLoadAfterLogin: async ({ commit }: any, params: any) => {
      commit("SET_LOAD_AFTER_LOGIN", params);
    },

    putMakeAsUnreadNotification: async ({ commit }: any, params: any) => {
      try {
        const response = await makeAsUnread(params);

        const { totalNew, action } = convertNotificationResponse(response);
        commit("SET_SYSTEM_ACTIONS", totalNew);
        commit("SET_NOTIFICATION", action);
      } catch (error) {
        showErrorAPI(error, UserRoute.putActionMakeAsUnread);
      }
    },
    deleteNotification: async ({ _ }: any, params: any) => {
      try {
        const response = await deleteNotification(params);
        if (response.status === 200) {
          store.dispatch("Notification/getNotification", {
            includeActioned: true,
          });
        }

        // BE error
        // const types = get(response, "data.data.types", []);
        // const totalNew = get(response, "data.data.totalNew", 0);

        // const action = types.flatMap(({ details, ...parent }) =>
        //   details.length > 0
        //     ? details.map((detail) => ({ ...parent, ...detail }))
        //     : [],
        // );

        // commit("SET_SYSTEM_ACTIONS", totalNew);
        // commit("SET_NOTIFICATION", action);
      } catch (error) {
        showErrorAPI(error, UserRoute.deleteNotification);
      }
    },

    deleteAllNotification: async ({ commit }) => {
      try {
        const res = await deleteAllNotification();
        if (res.status === 200) {
          commit("SET_SYSTEM_ACTIONS", 0);
          commit("SET_NOTIFICATION", []);

          showSuccessToast(
            getComponentUiText(
              "app-notification-delete-all-option-successfully-1",
            ),
          );
        }
      } catch (error) {
        showErrorAPI(error, UserRoute.deleteAllNotification);
      }
    },

    markAllAsReadNotification: async ({ commit }) => {
      try {
        const params = { includeActioned: true };

        const res = await markAllAsReadNotification(params);
        if (res.status !== successStatusCodes.OK) return;

        const { totalNew, action } = convertNotificationResponse(res);
        commit("SET_SYSTEM_ACTIONS", totalNew);
        commit("SET_NOTIFICATION", action);

        showSuccessToast(
          getComponentUiText(
            "app-notification-mark-read-option-successfully-1",
          ),
        );
      } catch (error) {
        showErrorAPI(error, UserRoute.markAllAsReadNotification);
      }
    },
  },
};
